<template>
  <el-dialog
    :title="titlebt"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <div  v-if="typeone">
    <el-form ref="form" :model="form" label-width="200px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
      <el-form-item label="可上传照片进行资料识别" class="grid-content bg-purple-dark">
      </el-form-item>

      <el-form-item label="证件扫描件" prop="idcards_front"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.idcards_front" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList4"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove2"
                :on-success="handlePictureCardPreview2">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="证件扫描件反面" prop="idcards_back"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form.idcards_back" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList5"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove3"
                :on-success="handlePictureCardPreview3">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <el-form ref="form2" :model="form2" label-width="180px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
      <el-form-item label="联系信息" class="grid-content bg-purple-dark">
      </el-form-item>

      <el-form-item label="姓名" prop="legal"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.legal"></el-input>
      </el-form-item>
      <el-form-item label="证件类型" prop="contractno"  :rules="[{ required: true, message: '不能为空'}]">
        <el-select
                class="filter-item"
                v-model="form2.contractno"
                placeholder="证件类型"
                width="50"
        >
          <el-option
                  v-for="item in sfzlxOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>


      <el-form-item label="证件号" prop="identification_number"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.identification_number"></el-input>
      </el-form-item>
      <el-form-item label="有效期" prop="identification_start"  :rules="[{ required: true, message: '不能为空'}]">
        <el-date-picker
                v-model="form2.identification_start"
                type="date"
                style="width:150px;"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>至 <el-date-picker
              v-model="form2.identification_end"
              type="date"
              style="width:150px;"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd">
      </el-date-picker>
      </el-form-item>
      <el-form-item label="法人手机号" prop="mobileNo"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.mobileNo"></el-input>
      </el-form-item>
      <el-form-item label="营业执照（小微商户请忽略）" prop="business_img" >
        <el-input v-model="form2.business_img" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                accept="image/png,image/gif,image/jpg,image/jpeg"
                list-type="picture-card"
                :limit=1
                :auto-upload="true"
                :file-list="fileList3"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :on-success="handlePictureCardPreview">
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="注册号" prop="business_number"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.business_number"></el-input>
      </el-form-item>
      <el-form-item label="名称" prop="agentname"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.agentname"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="one_type"  :rules="[{ required: true, message: '不能为空'}]">
        <el-select
                class="filter-item"
                v-model="form2.one_type"
                placeholder="类型"
                width="50"
        >
          <el-option
                  v-for="item in zjOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
    </el-form-item>
      <el-form-item label="地址" prop="compaddress"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.compaddress"></el-input>
      </el-form-item>
      <el-form-item label="法定代表人/经营者" prop="holder_name"  :rules="[{ required: true, message: '不能为空'}]">
        <el-input v-model="form2.holder_name"></el-input>
      </el-form-item>
      <el-form-item label="营业期限" prop="contractstdate"  :rules="[{ required: true, message: '不能为空'}]">
        <el-date-picker
                v-model="form2.contractstdate"
                type="date"
                style="width:150px;"
                :picker-options="pickerOptions" value-format="yyyy-MM-dd">
        </el-date-picker>至 <el-date-picker
              v-model="form2.contractendate"
              type="date"
              style="width:150px;"
              :picker-options="pickerOptions" value-format="yyyy-MM-dd">
      </el-date-picker>
      </el-form-item>
    </el-form>
    </div>
    <div  v-if="typetwo">
      <el-form ref="form3" :model="form3" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
        <el-form-item label="结算信息" class="grid-content bg-purple-dark">

        </el-form-item>

        <el-form-item label="账户类型" prop="legal_type"  :rules="[{ required: true, message: '不能为空'}]">
          <el-select
                  class="filter-item"
                  v-model="form3.legal_type"
                  placeholder="账户类型"
                  width="50"
          >
            <el-option
                    v-for="item in settleTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="结算类型" prop="legal_settle"  :rules="[{ required: true, message: '不能为空'}]">

          <el-select
                  class="filter-item"
                  v-model="form3.legal_settle"
                  placeholder="结算类型"
                  @change="checkedAll17"
                  width="50"
          >
            <el-option
                    v-for="item in settleOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
         <!-- <a  href="https://glj-1301404213.cos.ap-guangzhou.myqcloud.com/agreement/sqs/%E9%9D%9E%E6%B3%95%E4%BA%BA%E7%BB%93%E7%AE%97%E6%8E%88%E6%9D%83%E4%B9%A6.pdf" download="非法人结算授权书.pdf">非法人结算授权书 </a>
          <a href="https://glj-1301404213.cos.ap-guangzhou.myqcloud.com/agreement/sqs/%E7%BB%93%E7%AE%97%E8%B4%A6%E6%88%B7%E7%A1%AE%E8%AE%A4%E4%B9%A6.docx" download="结算账户确认书.docx"> 结算账户确认书</a>
            <div>A:非法人结算授权书（营业执照为个体户，非法人收款下载）</div>
            <div> B:结算账户确认书（营业执照为企业，非法人收款下载）</div>-->
          <a  href="https://glj-1301404213.cos.ap-guangzhou.myqcloud.com/agreement/sqs/%E7%BB%93%E7%AE%97%E8%B4%A6%E6%88%B7%E7%A1%AE%E8%AE%A4%E4%B9%A62020V2-2.0.pdf" download="结算账户确认书.pdf">结算账户确认书</a>
          <div>A:非法人收款确认书（个体户，企业共用）</div>
        </el-form-item>
        <div  v-if="checked15_one">
        <el-form-item label="非法人授权书/结算账户确认书" prop="power_attorney"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.power_attorney" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList15"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove15"
                  :on-success="handlePictureCardPreview15">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>

        <el-form-item label="非法人身份证人像面" prop="legal_idcards_front"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.legal_idcards_front" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList16"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove16"
                  :on-success="handlePictureCardPreview16">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="非法人身份证国徽面" prop="legal_idcards_back"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.legal_idcards_back" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList17"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove17"
                  :on-success="handlePictureCardPreview17">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
          <el-form-item label="非法人银行预留号码" prop="legal_moblie"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="form3.legal_moblie"></el-input>
          </el-form-item>
          <el-form-item label="非法人身份证号" prop="legal_card"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="form3.legal_card"></el-input>
          </el-form-item>
        </div>
        <el-form-item label="请上传经营者银行卡/开户许可证照片" prop="industry_license"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.industry_license" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList6"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove7"
                  :on-success="handlePictureCardPreview7">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="开户总行银行" prop="deposit_bank"  :rules="[{ required: true, message: '不能为空'}]">


          <el-select
                  class="filter-item"
                  v-model="form3.deposit_bank"
                  placeholder="开户总行银行"
                  width="50"
          >
            <el-option
                    v-for="item in kfyhOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>

        </el-form-item>
        <el-form-item label="开户支行城市" prop="account_city"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.account_city"></el-input>
        </el-form-item>
        <el-form-item label="开户行所在支行" prop="bank_branch"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.bank_branch"></el-input><span style='color: red;'>选择其他银行请务必填写全称、如"深圳农村商业银行XXX支行"</span>
        </el-form-item>
        <el-form-item label="开户名称" prop="account_name"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.account_name"></el-input>
        </el-form-item>
        <el-form-item label="开户账号" prop="bank_account"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form3.bank_account"></el-input>
        </el-form-item>
      </el-form>
      <el-form ref="form4" :model="form4" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
        <el-form-item label="基本信息" class="grid-content bg-purple-dark">

        </el-form-item>
        <el-form-item label="店铺LOGO" prop="agentlogo"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.agentlogo" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList88"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove88"
                  :on-success="handlePictureCardPreview88">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="店铺门头照" prop="agent_face"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.agent_face" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList8"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove8"
                  :on-success="handlePictureCardPreview8">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="店内环境照片" prop="agent_shop"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.agent_shop" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList11"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove11"
                  :on-success="handlePictureCardPreview11">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="收银台照" prop="cashier_photo"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.cashier_photo" style="display:none" ></el-input>
          <el-upload
                  ref="upload"
                  :action="imgUrl"
                  accept="image/png,image/gif,image/jpg,image/jpeg"
                  list-type="picture-card"
                  :limit=1
                  :auto-upload="true"
                  :file-list="fileList21"
                  :before-upload="handleBeforeUpload"
                  :on-remove="handleRemove21"
                  :on-success="handlePictureCardPreview21">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
          <el-form-item
                  prop="prov_cd"
                  label="经营省市区"
                  :rules="[{ required: true, message: '不能为空'}]"
          >
            <el-select
                    class="filter-item"
                    v-model="form4.prov_cd"
                    placeholder="请选择省"
                    @change="currentSel(form4.prov_cd)"
            >
              <el-option
                      v-for="item in typeOptions"
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
                  prop="city"
                  label="市"
          >
            <el-select
                    class="filter-item"
                    v-model="form4.city"
                    placeholder="请选择市"
                    @change="currentSel2(form4.city)"
            >
              <el-option
                      v-for="item in typeOptions2"
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
                  prop="areaid"
                  label="区"
          >
            <el-select
                    class="filter-item"
                    v-model="form4.areaid"
                    placeholder="请选择区"
            >
              <el-option
                      v-for="item in typeOptions3"
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
              ></el-option>
            </el-select>
          </el-form-item>



        <el-form-item label="经营地址" prop="compaddress"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.compaddress"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="legal"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.legal"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="mobileNo"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.mobileNo"></el-input>
        </el-form-item>
        <el-form-item label="常用邮箱" prop="email"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.email"></el-input>
        </el-form-item>
        <el-form-item label="客服电话" prop="shop_tel"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.shop_tel"></el-input>
        </el-form-item>
        <el-form-item label="商户简称" prop="shortername"  :rules="[{ required: true, message: '不能为空'}]">
          <el-input v-model="form4.shortername"></el-input>
        </el-form-item>
      </el-form>
    </div>
      <div  v-if="typethree">
        <el-form ref="form5" :model="form5" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
          <el-form-item label="随行付通道" class="grid-content bg-purple-dark">
            <el-checkbox v-model="checked1" @change="checkedAll1" ></el-checkbox>
          </el-form-item>
          <div  v-if="checked1_one">
            <el-form-item label="经营类目"  prop="jy_lm_sxf"  :rules="[{ required: true, message: '不能为空'}]">
              <el-select
                      class="filter-item"
                      v-model="form5.jy_lm_sxf"
                      placeholder="经营类目"
                      width="50"
              >
                <el-option
                        v-for="item in sxfOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费率(%)" prop="rate_sxf"  :rules="[{ required: true, message: '不能为空'}]">
              <el-slider
                      v-model="form5.rate_sxf"
                      show-input>
              </el-slider>
            </el-form-item>
          </div>

          <div  v-if="checked1_two">
            <el-form-item label="经营类目"  prop="jy_lm_sxf">
              <el-select
                      class="filter-item"
                      v-model="form5.jy_lm_sxf"
                      placeholder="经营类目"
                      width="50"
              >
                <el-option
                        v-for="item in sxfOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="费率(%)" prop="rate_sxf">
              <el-slider
                      v-model="form5.rate_sxf"
                      show-input>
              </el-slider>
            </el-form-item>
          </div>
        </el-form>


        <el-form ref="form6" :model="form6" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
          <el-form-item label="微信官方通道" class="grid-content bg-purple-dark">
            <el-checkbox v-model="checked2" @change="checkedAll2" ></el-checkbox>
          </el-form-item>
          <div  v-if="checked2_one">
          <el-form-item label="经营描述" prop="business_description"  :rules="[{ required: true, message: '不能为空'}]">
            <el-select
                    class="filter-item"
                    v-model="form6.business_description"
                    placeholder="经营描述"
                    width="50"
            >
              <el-option
                      v-for="item in bdOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="经营行业" prop="business_sector"  :rules="[{ required: true, message: '不能为空'}]">
            <el-select
                    class="filter-item"
                    v-model="form6.business_sector"
                    placeholder="经营描述"
                    width="50"
            >
              <el-option
                      v-for="item in bsOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          </div>

          <div  v-if="checked2_two">
            <el-form-item label="经营描述" prop="business_description">
              <el-select
                      class="filter-item"
                      v-model="form6.business_description"
                      placeholder="经营描述"
                      width="50"
              >
                <el-option
                        v-for="item in bdOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="经营行业" prop="business_sector" >
              <el-select
                      class="filter-item"
                      v-model="form6.business_sector"
                      placeholder="经营描述"
                      width="50"
              >
                <el-option
                        v-for="item in bsOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="特殊资质" prop="special_qualification" >
            <el-input v-model="form6.special_qualification" style="display:none" ></el-input>
            <el-upload
                    ref="upload"
                    :action="imgUrl"
                    accept="image/png,image/gif,image/jpg,image/jpeg"
                    list-type="picture-card"
                    :limit=1
                    :auto-upload="true"
                    :file-list="fileList9"
                    :before-upload="handleBeforeUpload"
                    :on-remove="handleRemove9"
                    :on-success="handlePictureCardPreview9">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
        </el-form>

        <el-form ref="form7" :model="form7" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
          <el-form-item label="支付宝" class="grid-content bg-purple-dark">
            <el-checkbox v-model="checked3" @change="checkedAll3" ></el-checkbox>
          </el-form-item>
          <div  v-if="checked3_one">
          <el-form-item label="商家支付宝账号" prop="alipay_account"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="form7.alipay_account"></el-input>
          </el-form-item>
          </div>
          <div  v-if="checked3_two">
            <el-form-item label="商家支付宝账号" prop="alipay_account">
              <el-input v-model="form7.alipay_account"></el-input>
            </el-form-item>
          </div>
        </el-form>

        <el-form ref="form8" :model="form8" label-width="140px"  style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)">
          <el-form-item label="银盛通道" class="grid-content bg-purple-dark">
            <el-checkbox v-model="checked4" @change="checkedAll4" ></el-checkbox>
          </el-form-item>
          <div  v-if="checked4_one">
          <el-form-item label="经营类目" prop="jy_lm_ys"  :rules="[{ required: true, message: '不能为空'}]">
            <el-select
                    class="filter-item"
                    v-model="form8.jy_lm_ys"
                    placeholder="经营类目"
                    width="50"
            >
              <el-option
                      v-for="item in ysOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算费率(%)" prop="rate_ys"  :rules="[{ required: true, message: '不能为空'}]">
            <el-slider
                    v-model="form8.rate_ys"
                    show-input>
            </el-slider>
          </el-form-item>
          <el-form-item label="商家协议" prop="merchant_agreement"  :rules="[{ required: true, message: '不能为空'}]">
            <el-input v-model="form8.merchant_agreement" style="display:none" ></el-input>
            <el-upload
                    ref="upload"
                    :action="imgUrl"
                    accept="image/png,image/gif,image/jpg,image/jpeg"
                    list-type="picture-card"
                    :limit=1
                    :auto-upload="true"
                    :file-list="fileList10"
                    :before-upload="handleBeforeUpload"
                    :on-remove="handleRemove10"
                    :on-success="handlePictureCardPreview10">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          </div>

          <div  v-if="checked4_two">
            <el-form-item label="经营类目" prop="jy_lm_ys" >
              <el-select
                      class="filter-item"
                      v-model="form8.jy_lm_ys"
                      placeholder="经营类目"
                      width="50"
              >
                <el-option
                        v-for="item in ysOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算费率(%)" prop="rate_ys" >
              <el-slider
                      v-model="form8.rate_ys"
                      show-input>
              </el-slider>
            </el-form-item>
            <el-form-item label="商家协议" prop="merchant_agreement">
              <el-input v-model="form8.merchant_agreement" style="display:none" ></el-input>
              <el-upload
                      ref="upload"
                      :action="imgUrl"
                      accept="image/png,image/gif,image/jpg,image/jpeg"
                      list-type="picture-card"
                      :limit=1
                      :auto-upload="true"
                      :file-list="fileList10"
                      :before-upload="handleBeforeUpload"
                      :on-remove="handleRemove10"
                      :on-success="handlePictureCardPreview10">
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </div>
        </el-form>

    </div>

    <el-button  v-if="isup"
            type="primary"
            :loading="loading"
            @click="upp"
    >上一步</el-button>
    <el-button  v-if="xyb"
            type="primary"
            :loading="loading"
            @click="next"
    >下一步</el-button>
    <el-button  v-if="tj"
            type="primary"
            :loading="loading"
            @click="tjgl"
    >提交</el-button>
  </el-dialog>


</template>
<style>
  .customWidth{
    width:80%;
    height: 80%;
  }
  .bg-purple-dark {
    background: #e5e9f2;
  }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import * as userService from "@/api/sys/user";
    import util from '@/libs/util.js'
export default {
  name: "oldpartsEditForm",
    components:{
    },
  props: {
      agent: Object,
    value: Boolean
  },
  data() {
    return {
        checked1_one:true,
        checked1_two:false,
        checked2_one:true,
        checked2_two:false,
        checked3_one:true,
        checked3_two:false,
        checked4_one:true,
        checked4_two:false,
        checked15_one:false,
        xzgl_one:false,
        xzgl_two:false,
        checked1: true,
        checked2: true,
        checked3: true,
        checked4: true,
        titlebt:"",
        imgUrl: process.env.VUE_APP_API+"/moblieapp/currencyUpload",
        loading: false,
        dialogVisible: false,
        isup:false,
        xyb:true,
        active: 0,
        typeone: true,
        typetwo: false,
        typethree:false,
        tj:false,
        form: {
            idcards_front: '',
            idcards_back:''
        },
        typeOptions: [],
        typeOptions2: [],
        typeOptions3: [],
        zjOptions: [
            {
                value: "2",
                label: "企业"
            },
            {
                value: "1",
                label: "个体工商户"
            },
            {
                value: "300",
                label: "小微商户"
            }
        ],
        settleOptions: [
            {
                value: "0",
                label: "法人结算"
            },
            {
                value: "1",
                label: "非法人结算"
            }
        ],
        settleTypeOptions: [
            {
                value: "对私账户",
                label: "对私账户"
            },
            {
                value: "对公账户",
                label: "对公账户"
            }
        ],
        bdOptions: [
            {
                value: "餐饮",
                label: "餐饮"
            },
            {
                value: "线下零售",
                label: "线下零售"
            },
            {
                value: "居民生活服务",
                label: "居民生活服务"
            },
            {
                value: "休闲娱乐",
                label: "休闲娱乐"
            },
            {
                value: "交通出行",
                label: "交通出行"
            },
            {
                value: "其他",
                label: "其他"
            }
        ],
        bsOptions: [
            {
                value: "餐饮",
                label: "餐饮"
            },
            {
                value: "加油",
                label: "加油"
            },
            {
                value: "食品生鲜",
                label: "食品生鲜"
            },
            {
                value: "游艺厅/KTV/网吧",
                label: "游艺厅/KTV/网吧"
            },
            {
                value: "零售批发/生活娱乐/其他",
                label: "零售批发/生活娱乐/其他"
            }
        ],
        sxfOptions: [
            {
                value: "公益类",
                label: "公益类"
            },
            {
                value: "餐娱类",
                label: "餐娱类"
            },
            {
                value: "民生类",
                label: "民生类"
            },
            {
                value: "一般类",
                label: "一般类"
            }
        ],
        sfzlxOptions: [
            {
                value: "身份证",
                label: "身份证"
            },
            {
                value: "台湾身份证",
                label: "台湾身份证"
            },
            {
                value: "香港身份证",
                label: "香港身份证"
            },
            {
                value: "澳门身份证",
                label: "澳门身份证"
            },
            {
                value: "港澳台通行证",
                label: "港澳台通行证"
            }
        ],
        kfyhOptions: [
            {
                value: "工商银行",
                label: "工商银行"
            },
            {
                value: "交通银行",
                label: "交通银行"
            },
            {
                value: "招商银行",
                label: "招商银行"
            },
            {
                value: "民生银行",
                label: "民生银行"
            },
            {
                value: "中信银行",
                label: "中信银行"
            },
            {
                value: "浦发银行",
                label: "浦发银行"
            },
            {
                value: "兴业银行",
                label: "兴业银行"
            },
            {
                value: "光大银行",
                label: "光大银行"
            },
            {
                value: "广发银行",
                label: "广发银行"
            },
            {
                value: "平安银行",
                label: "平安银行"
            },
            {
                value: "北京银行",
                label: "北京银行"
            },
            {
                value: "华夏银行",
                label: "华夏银行"
            },
            {
                value: "农业银行",
                label: "农业银行"
            },
            {
                value: "建设银行",
                label: "建设银行"
            },
            {
                value: "邮政储蓄银行",
                label: "邮政储蓄银行"
            },
            {
                value: "中国银行",
                label: "中国银行"
            },
            {
                value: "宁波银行",
                label: "宁波银行"
            },
            {
                value: "其他银行",
                label: "其他银行"
            }
        ],
        ysOptions: [
            {
                value: "零售业",
                label: "零售业"
            },
            {
                value: "住宿、餐饮和休闲娱乐业",
                label: "住宿、餐饮和休闲娱乐业"
            },
            {
                value: "居民服务与商业服务",
                label: "居民服务与商业服务"
            },
            {
                value: "教育、卫生、福利及其他政府服务",
                label: "教育、卫生、福利及其他政府服务"
            },
            {
                value: "房地产与金融业",
                label: "房地产与金融业"
            }
        ],
        pickerOptions: {}, // 日期设置对象
        fileList3: [],
        fileList4: [],
        fileList5: [],
        fileList6: [],
        fileList8: [],
        fileList88: [],
        fileList9: [],
        fileList10: [],
        fileList11: [],
        fileList21: [],
        fileList15: [],
        fileList16: [],
        fileList17: [],
        form2:{
            legal:'',
            contractno:'',
            identification_number:'',
            identification_start:'',
            identification_end:'',
            mobileNo:'',
            business_img:'',
            business_number:'',
            agentname:'',
            one_type:'',
            compaddress:'',
            holder_name:'',
            contractstdate:'',
            contractendate:''
        },
        form3:{
            industry_license:'',
            legal_settle:'',
            legal_type:'',
            legal_moblie:'',
            legal_card:'',
            legal_idcards_front:'',
            legal_idcards_back:'',
            power_attorney:'',
            deposit_bank:'',
            account_city:'',
            bank_branch:'',
            account_name:'',
            bank_account:''
        },
        form4:{
            agent_face:'',
            agentlogo:'',
            agent_shop:'',
            cashier_photo:'',
            prov_cd: '',
            city: '',
            areaid: '',
            compaddress:'',
            legal:'',
            mobileNo:'',
            email:'',
            shop_tel:'',
            shortername:''


        },
        form5:{
            jy_lm_sxf:'',
            rate_sxf:'0'

        },
        form6:{
            business_description:'',
            business_sector:'',
            special_qualification:''

        },
        form7:{
            alipay_account:''

        },
        form8:{
            jy_lm_ys:'',
            rate_ys:'0',
            merchant_agreement:''

        }
    };
  },
  watch: {
    value(val) {
      this.dialogVisible = val;
    },
      dialogVisible(val) {
      this.$emit("input", val);
    }
  },
  methods: {
    dialogOpen() {
        this.titlebt="录入资料("+this.agent.agentname+")";

        var formData2 = new FormData() // 声明一个FormData对象
        agentService.getProvcd(formData2).then(data => {
            this.typeOptions=data;
        });
        if(this.agent.city){
            this.currentSel(this.agent.prov_cd);
        }
        if(this.agent.areaid){
            this.currentSel2(this.agent.city);
        }

        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",this.agent.agentid);
        agentService.getPerfectAgent(formData4).then(data => {
            this.agentOpen(data);
        });

        this.form4.prov_cd = this.agent.prov_cd;
        this.form4.city = this.agent.city;
        this.form4.areaid = this.agent.areaid;
    },
      agentOpen(data){
          if(data!=null && data!="") {
              this.oneagent = data;
              console.log("data.legal===" + data.legal);
              if (data.idcards_front != null && data.idcards_front != ""&& data.idcards_front != "null") {
                  this.fileList4 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.idcards_front}]
                  this.form.idcards_front = data.idcards_front;
              }

              if (data.idcards_back != null && data.idcards_back != ""&& data.idcards_back != "null") {
                  this.fileList5 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.idcards_back}]
                  this.form.idcards_back = data.idcards_back;
              }
              this.form2.legal = data.legal;
              this.form2.identification_number = data.identification_number;
              if (data.identification_start !== null && data.identification_start != "" && data.identification_start != "null") {
                  console.log("data.identification_start===" + data.identification_start);
                  this.form2.identification_start = data.identification_start;
              }
              if (data.identification_end != null && data.identification_end != "" && data.identification_end != "null") {
                  this.form2.identification_end = data.identification_end;
              }
              this.form2.mobileNo=data.mobileNo;

              if(data.business_img!=null && data.business_img!=""&& data.business_img != "null") {
                  this.fileList3 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.business_img}]
                  this.form2.business_img = data.business_img;
              }
              this.form2.business_number=data.business_number;
              this.form2.agentname=data.agentname;
              this.form2.compaddress=data.compaddress;
              this.form2.holder_name=data.holder_name;
              if (data.contractstdate != null && data.contractstdate != "" && data.contractstdate != "null") {
                  this.form2.contractstdate = data.contractstdate;
              }
              if (data.contractendate != null && data.contractendate != "" && data.contractendate != "null") {
                  this.form2.contractendate = data.contractendate;
              }
              if (data.contractno != null && data.contractno != "" && data.contractno != "null") {
                  this.form2.contractno = data.contractno;
              }
              this.form2.one_type=data.one_type;

              if(data.industry_license!=null && data.industry_license!="" && data.industry_license != "null") {
                  this.fileList6 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.industry_license}]
                  this.form3.industry_license = data.industry_license;
              }
              this.form3.deposit_bank=data.deposit_bank;
              this.form3.account_city=data.account_city;
              this.form3.bank_branch=data.bank_branch;
              this.form3.account_name=data.account_name;
              this.form3.bank_account=data.bank_account;

              if(data.agent_face!=null && data.agent_face!="" && data.agent_face != "null") {
                  this.fileList8 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.agent_face}]
                  this.form4.agent_face = data.agent_face;
              }
              if(data.agentlogo!=null && data.agentlogo!="" && data.agentlogo != "null") {
                  this.fileList88 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.agentlogo}]
                  this.form4.agentlogo = data.agentlogo;
              }
              if(data.agent_shop!=null && data.agent_shop!="" && data.agent_shop != "null") {
                  this.fileList11 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.agent_shop}]
                  this.form4.agent_shop = data.agent_shop;
              }

              if(data.cashier_photo!=null && data.cashier_photo!="" && data.cashier_photo != "null") {
                  this.fileList21 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.cashier_photo}]
                  this.form4.cashier_photo = data.cashier_photo;
              }

              if(data.power_attorney!=null && data.power_attorney!="" && data.power_attorney != "null") {
                  this.fileList15 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.power_attorney}]
                  this.form3.power_attorney = data.power_attorney;
              }

              if(data.legal_idcards_front!=null && data.legal_idcards_front!="" && data.legal_idcards_front != "null") {
                  this.fileList16 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.legal_idcards_front}]
                  this.form3.legal_idcards_front = data.legal_idcards_front;
              }

              if(data.legal_idcards_back!=null && data.legal_idcards_back!="" && data.legal_idcards_back != "null") {
                  this.fileList17 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.legal_idcards_back}]
                  this.form3.legal_idcards_back = data.legal_idcards_back;
              }

              if(data.legal_settle!=null && data.legal_settle!="" && data.legal_settle != "null") {
                  this.form3.legal_settle = data.legal_settle;
               if(data.legal_settle=='1'){
                   this.checked15_one=true;

                 /**  if(data.legal_type=='对公账户'){
                       this.xzgl_one=false;
                       this.xzgl_two=true;
                   }else{
                       this.xzgl_one=true;
                       this.xzgl_two=false;
                   }**/




                  }
              }

              if(data.legal_type!=null && data.legal_type!="" && data.legal_type != "null") {
                  this.form3.legal_type = data.legal_type;
              }
              if(data.legal_moblie!=null && data.legal_moblie!="" && data.legal_moblie != "null") {
                  this.form3.legal_moblie = data.legal_moblie;
              }

              if(data.legal_card!=null && data.legal_card!="" && data.legal_card != "null") {
                  this.form3.legal_card = data.legal_card;
              }




              this.form4.compaddress=data.compaddress;
              this.form4.legal=data.legal;
              this.form4.mobileNo=data.mobileNo;
              this.form4.email=data.email;
              this.form4.shop_tel=data.shop_tel;
              this.form4.shortername=data.shortername;

              this.form5.jy_lm_sxf=data.jy_lm_sxf;
              this.form5.rate_sxf=data.rate_sxf;

              this.form6.business_description=data.business_description;
              this.form6.business_sector=data.business_sector;
              if(data.special_qualification!=null && data.special_qualification!=""  && data.special_qualification != "null") {
                  this.fileList9 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.special_qualification}]
                  this.form6.special_qualification = data.special_qualification;
              }


              this.form7.alipay_account=data.alipay_account;


              this.form8.jy_lm_ys=data.jy_lm_ys;
              this.form8.rate_ys=data.rate_ys;
              if(data.merchant_agreement!=null && data.merchant_agreement!=""   && data.merchant_agreement != "null") {
                  this.fileList10 = [{url: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.merchant_agreement}]
                  this.form8.merchant_agreement = data.merchant_agreement;
              }


          }
      },
      handleClick(tab, event) {
          console.log(tab, event);

      },
      checkedAll1(event){
        if(event){
            this.checked1_one=true;
            this.checked1_two=false;
        }else{
            this.checked1_one=false;
            this.checked1_two=true;
        }
          console.log("选中"+event);
      },
      checkedAll17(value){
          if(value==1){

              this.checked15_one=true;
             /** if(this.form3.legal_type=='对公账户'){
                  this.xzgl_one=false;
                  this.xzgl_two=true;
              }else{
                  this.xzgl_one=true;
                  this.xzgl_two=false;
              }**/


          }else{
              this.checked15_one=false;

          }
      },
      checkedAll2(event){
          if(event){
              this.checked2_one=true;
              this.checked2_two=false;
          }else{
              this.checked2_one=false;
              this.checked2_two=true;
          }
          console.log("选中"+event);
      },
      checkedAll3(event){
          if(event){
              this.checked3_one=true;
              this.checked3_two=false;
          }else{
              this.checked3_one=false;
              this.checked3_two=true;
          }
          console.log("选中"+event);
      },
      checkedAll4(event){
          if(event){
              this.checked4_one=true;
              this.checked4_two=false;
          }else{
              this.checked4_one=false;
              this.checked4_two=true;
          }
          console.log("选中"+event);
      },
      next() {
        if(this.active==0){
            this.$refs["form"].validate(valid => {
                if (valid) {
                    this.$refs["form2"].validate(valid => {
                            if (valid) {
                                agentService.saveAgentNewJjOne({ ...this.form, ...this.form2,userId:this.agent.userId,agentid:this.agent.agentid})
                                    .then(data => {
                                        this.agentOpen(data);
                                this.typeone=false;
                                this.typetwo=true;
                                this.typethree=false;
                                this.tj=false;
                                this.isup=true;
                                this.xyb=true;
                                if(this.active<5){
                                    this.active++;

                                }
                                    });
                            }else{
                                return false;
                            }
                    });

                }else{
                    return false;
                }
            });
        }else if(this.active==1){


            this.$refs["form3"].validate(valid => {
                if (valid) {
                    this.$refs["form4"].validate(valid => {
                        if (valid) {
                            agentService.saveAgentNewJjTwo({ ...this.form3, ...this.form4,userId:this.agent.userId,agentid:this.agent.agentid})
                                .then(data => {
                                    this.typeone=false;
                                    this.typetwo=false;
                                    this.typethree=true;
                                    this.tj=true;
                                    this.isup=true;
                                    this.xyb=false;
                                    if(this.active<5){
                                        this.active++;

                                    }
                                });
                        }else{
                            return false;
                        }
                    });

                }else{
                    return false;
                }
            });



          }




      }
      ,
      tjgl() {
          let msg = "进件";
          this.$confirm("确认"+msg+"操作？", "确认信息", {
              distinguishCancelAndClose: true,
              confirmButtonText: msg,
              cancelButtonText: "取消"
          }).then(() => {
              this.$refs["form5"].validate(valid => {
                  if (valid) {
                      this.$refs["form6"].validate(valid => {
                          if (valid) {


                              this.$refs["form7"].validate(valid => {
                                  if (valid) {



                                      this.$refs["form8"].validate(valid => {
                                          if (valid) {

                                                                                         this.loading = true;

                                              agentService.saveAgentNewJjThree({ ...this.form5, ...this.form6, ...this.form7, ...this.form8,userId:this.agent.userId,agentid:this.agent.agentid})
                                                  .then(data => {
                                                      this.loading = false;
                                                      this.dialogVisible = false;
                                                      this.$emit("submit");
                                                  });


                                          }else{
                                              return false;
                                          }
                                      });


                                  }else{
                                      return false;
                                  }
                              });




                          }else{
                              return false;
                          }
                      });

                  }else{
                      return false;
                  }
              });

          });
      },
      currentSel(val) {
          if (this.agent.userId) {
              this.form4.city = "";
              this.form4.areaid = "";
          }
          this.typeOptions2=[];
          var formData2 = new FormData() // 声明一个FormData对象

          formData2.append('type','city')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions2=data;
          });
      },
      currentSel2(val) {
          this.typeOptions3=[];
          var formData2 = new FormData() // 声明一个FormData对象
          formData2.append('type','area')
          formData2.append('areaid',val)
          agentService.getProvcd(formData2).then(data => {
              this.typeOptions3=data;
          });
      },
      upp() {
          console.log(this.active);
          if(this.active==1){
              this.typeone=true;
              this.typetwo=false;
              this.typethree=false;
              this.isup=false;
              this.tj=false;
              this.xyb=true;
          }else if(this.active==2){
              this.typeone=false;
              this.typetwo=true;
              this.typethree=false;
              this.typefour=false;
              this.isup=true;
              this.tj=false;
              this.xyb=true;
          }

          if(this.active>0){
              this.active--;

          }


      },
      // 上传文件之前的钩子
      handleBeforeUpload(file){
          let isJPG =true;
          // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
          console.log('before');
          if(!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
              isJPG=false;
              this.$notify.warning({
                  title: '警告',
                  message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
              })

          }
          let size = file.size / 1024 / 1024 / 2
          if(size > 2) {
              this.$notify.warning({
                  title: '警告',
                  message: '图片大小必须小于2M'
              })
              isJPG=false;
          }

          return isJPG // 返回false不会自动上传
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove5(file) {
          this.form.special_qualification = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove6(file) {
          this.form.supple_materials = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview5(file) {
          console.log("=======file.url=========="+file.url);
          this.form.special_qualification = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview6(file) {
          console.log("=======file.url=========="+file.url);
          this.form.supple_materials = file.url;
          this.dialogVisible = true;
      },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview(file) {
        console.log("=======file.url=========="+file.url);
        this.form2.business_img = file.url;
        this.dialogVisible = true;
    },
    // 点击文件列表中已上传的文件时的钩子
    handleRemove(file) {
        this.form2.business_img ="";
        this.dialogVisible = true;
    }, // 点击文件列表中已上传的文件时的钩子
      handleRemove7(file) {
          this.form3.industry_license = "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview7(file) {
          console.log("=======file.url=========="+file.url);
          this.form3.industry_license = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove15(file) {
          this.form3.power_attorney = "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview15(file) {
          console.log("=======file.url=========="+file.url);
          this.form3.power_attorney = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove16(file) {
          this.form3.legal_idcards_front = "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview16(file) {
          console.log("=======file.url=========="+file.url);
          this.form3.legal_idcards_front = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove17(file) {
          this.form3.legal_idcards_back = "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview17(file) {
          console.log("=======file.url=========="+file.url);
          this.form3.legal_idcards_back = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove8(file) {
          this.form4.agent_face = "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview8(file) {
          console.log("=======file.url=========="+file.url);
          this.form4.agent_face = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove88(file) {
          this.form4.agentlogo = "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview88(file) {
          console.log("=======file.url=========="+file.url);
          this.form4.agentlogo = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove9(file) {
          this.form6.special_qualification= "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview9(file) {
          console.log("=======file.url=========="+file.url);
          this.form6.special_qualification = file.url;
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handleRemove10(file) {
          this.form8.merchant_agreement= "";
          this.dialogVisible = true;
      }, // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview10(file) {
          console.log("=======file.url=========="+file.url);
          this.form8.merchant_agreement = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove3(file) {
          this.form.idcards_back = "";
          this.dialogVisible = true;
      },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview3(file) {
        console.log("=======file.url=========="+file.url);
        this.form.idcards_back = file.url;
        this.dialogVisible = true;
    },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove2(file) {
          this.form.idcards_front = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview2(file) {
          console.log("=======file.url=========="+file.url);
          this.form.idcards_front = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove11(file) {
          this.form4.agent_shop = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview11(file) {
          console.log("=======file.url=========="+file.url);
          this.form4.agent_shop = file.url;
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handleRemove21(file) {
          this.form4.cashier_photo = "";
          this.dialogVisible = true;
      },
      // 点击文件列表中已上传的文件时的钩子
      handlePictureCardPreview21(file) {
          console.log("=======file.url=========="+file.url);
          this.form4.cashier_photo = file.url;
          this.dialogVisible = true;
      },
    close() {
      this.dialogVisible = false;
    }
  }
};
</script>

